/* tslint:disable */
import { Component, OnInit } from '@angular/core';
import { AuthService } from './auth.service';
import { Usuario } from './usuario';
import { Http } from '@angular/http';
import { ConfigProvider } from 'providers/config/config';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  lottieConfig: any;
  login: any;
  usuario: Usuario = new Usuario();
  logo = 'assets/img/logo.png';
  urlToJson = 'assets/login/passwd.json';
  constructor(private authService: AuthService, 
              public http: Http,
              public configProvider: ConfigProvider) {

  }

  ngOnInit() {
    let usuario = JSON.parse(this.configProvider.getConfigData());
    if (!usuario){
 /*
      this.http.get(this.urlToJson).subscribe(response => {
        let data = JSON.parse(JSON.stringify(response));
        let loginUser = JSON.parse(data._body);
        this.usuario.nome = loginUser.login
        this.usuario.senha = loginUser.senha
        if (loginUser.autoLogin) {
          setTimeout(() => {
            this.authService.fazerLogin(this.usuario)
          }, 1000);
        } else {
    //      alert ("nao logar")
        }
      });
      */
    } else {
        this.usuario.nome = usuario.login
        this.usuario.senha = usuario.senha
        setTimeout(() => {
          this.authService.fazerLogin(this.usuario)
        }, 3000);
    }


  }
  clearLogin(){
   this.configProvider.clearStorage();
  }
  onSubmit(formulario) {
    this.authService.fazerLogin(formulario.value);
  }

}



// WEBPACK FOOTER //
// D:/desv/producao/ITN/srvHCWaba/src/app/login/login.component.ts